import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { Dropdown, Space, message } from 'antd'
import MyAvatar from '../components/avatar'
import ChangePwd from './changepwd'
import EditProfile from './editProfile'
import EditWelcomeMsg from './editWelcomeMsg'
import UnbindWechat from './unbindWechat'
import BindingWechat  from './bindingWechat'
import Qrcode from './qrcode'

const People = () => {
  const navigate = useNavigate()
  const [propsData, setPropsData] = useState({})
  const [accountDetail, setAccountDetail] = useState({})
  const [isChangePwdVisible, setIsChangePwdVisible] = useState(false)
  const [isEditProfileVisible, setIsEditProfileVisible] = useState(false)
  const [isEditWelcomeMsgVisible, setIsEditWelcomeMsgVisible] = useState(false)
  const [isAdvisoryLinkVisible, setIsAdvisoryLinkVisible] = useState(false)
  const [isUnbindWechatVisible, setIsUnbindWechatVisible] = useState(false)
  const [isBindingWechatVisible, setIsBindingWechatVisible] = useState(false)

  const fetchAcountDetail = () => {
    axios.post('/c/kf_b/account/get')
      .then(function (response) {
        if (response.errcode === 0) {
          setAccountDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    fetchAcountDetail()
  }, [])

  const editProfile = () => {
    setPropsData({ info: accountDetail })
    setIsEditProfileVisible(true)
  }

  const handleChangePwd = () => {
    setIsChangePwdVisible(true)
  }

  const setWelcomeMsg = () => {
    setPropsData({ info: accountDetail })
    setIsEditWelcomeMsgVisible(true)
  }

  const viewAdvisoryLink = () => {
    setIsAdvisoryLinkVisible(true)
    setPropsData({ address: 'https://kf-c.yunzhaosoft.com/chat/' + accountDetail.oid})
  }

  const unbindWechat = () => {
    setIsUnbindWechatVisible(true)
  }

  const handleLogout = () => {
    const oid = localStorage.getItem('oid')
    localStorage.removeItem('token')
    navigate('/login/' + oid)
    message.success('退出登录成功')
  }

  const items = [
    {
      label: (
        <div className="people-personal">
          <MyAvatar userObject={accountDetail} avatarSize={46}/>
          <div className="people-box">
            <div className="people-nickname">{accountDetail.nickname}</div>
            <div className="people-username">{accountDetail.username}</div>
          </div>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      label: <div onClick={editProfile}>编辑资料</div>,
    },
    {
      label: <div onClick={handleChangePwd}>修改密码</div>,
    },
    {
      label: <div onClick={setWelcomeMsg}>设置欢迎语</div>,
    },
    {
      label: <div onClick={viewAdvisoryLink}>咨询链接</div>,
    },
    ...(accountDetail.mp_openid ? [{
      label: <div onClick={unbindWechat}>关闭消息通知</div>,
    }] : []),
    {
      label: <div onClick={handleLogout}>退出登录</div>,
    },
  ]

  return (
    <>
      <div className="people-container">
        {!accountDetail.mp_openid &&
          <div className="people-bind" onClick={() => { setIsBindingWechatVisible(true) }}>开启消息通知</div>
        }
        <div className='people-avatar'>
          <Dropdown menu={{ items }} trigger={['click']} overlayStyle={{ width: '280px'}}>
            <Link onClick={(e) => e.preventDefault()}>
              <Space>
                <MyAvatar userObject={accountDetail} avatarSize={36} fontSize='14px'/>
              </Space>
            </Link>
          </Dropdown>
        </div>
      </div>

      {isEditProfileVisible && <EditProfile
        data={propsData}
        isOpen={isEditProfileVisible}
        fetchAcountDetail={fetchAcountDetail}
        isCancel={() => { setIsEditProfileVisible(false) }}
      />}

      {isEditWelcomeMsgVisible && <EditWelcomeMsg
        data={propsData}
        isOpen={isEditWelcomeMsgVisible}
        fetchAcountDetail={fetchAcountDetail}
        isCancel={() => { setIsEditWelcomeMsgVisible(false) }}
      />}

      {isChangePwdVisible && <ChangePwd
        isOpen={isChangePwdVisible}
        isCancel={() => { setIsChangePwdVisible(false) }}
      />}

      {isAdvisoryLinkVisible && <Qrcode
        data={propsData}
        isOpen={isAdvisoryLinkVisible}
        isCancel={() => { setIsAdvisoryLinkVisible(false) }}
      />}

      {isUnbindWechatVisible && <UnbindWechat
        isOpen={isUnbindWechatVisible}
        fetchAcountDetail={fetchAcountDetail}
        isCancel={() => { setIsUnbindWechatVisible(false) }}
      />}

      {isBindingWechatVisible && <BindingWechat
        isOpen={isBindingWechatVisible}
        fetchAcountDetail={fetchAcountDetail}
        isCancel={() => { setIsBindingWechatVisible(false) }}
      />}
    </>
  )
}

export default People
